import type { JSX } from 'react';

import { ArrowLeftIcon, ArrowRightIcon } from '@change/ds-icons';

type NavigationArrowsProps = {
	canScrollLeft: boolean;
	canScrollRight: boolean;
	onScrollLeft: () => void;
	onScrollRight: () => void;
};

export function NavigationArrows({
	canScrollLeft,
	canScrollRight,
	onScrollLeft,
	onScrollRight,
}: NavigationArrowsProps): JSX.Element {
	return (
		<>
			{canScrollLeft && (
				<button
					aria-label="Scroll left"
					className="border-stroke-weaker absolute left-0 top-1/2 z-10 hidden h-9 w-9 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-solid bg-white md:flex"
					onClick={onScrollLeft}
					data-testid="carousel-scroll-left"
					data-qa="carousel-scroll-left"
					type="button"
				>
					<ArrowLeftIcon className="h-5 w-5" size={20} />
				</button>
			)}
			{canScrollRight && (
				<button
					aria-label="Scroll right"
					className="border-stroke-weaker absolute right-0 top-1/2 z-10 hidden h-9 w-9 -translate-y-1/2 translate-x-1/2 items-center justify-center rounded-full border border-solid bg-white md:flex"
					onClick={onScrollRight}
					data-testid="carousel-scroll-right"
					data-qa="carousel-scroll-right"
					type="button"
				>
					<ArrowRightIcon className="h-5 w-5" size={20} />
				</button>
			)}
		</>
	);
}
